import { Typography } from "@mui/material";

function WrapperInventory({ data }) {
  return (
    <Typography
      variant="h6"
      fontWeight={600}
      color={
        data.valueStart > 0
          ? "success.main"
          : data.valueStart < 0
          ? "error.main"
          : "text.main"
      }
    >
      {data.valueStart > 0 && "+"}
      {data.valueStart}
    </Typography>
  );
}

export default WrapperInventory;
